var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconLightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43842 0.21967C7.14553 0.512563 7.14553 0.987437 7.43842 1.28033L9.43934 3.28125H3.375C2.47989 3.28125 1.62145 3.63683 0.988515 4.26976C0.35558 4.9027 0 6.04239 0 6.9375V11.25C0 11.6642 0.335786 12 0.75 12C1.16421 12 1.5 11.6642 1.5 11.25V6.9375C1.5 6.44022 1.69754 5.68206 2.04918 5.33042C2.40081 4.97879 2.87772 4.78125 3.375 4.78125H9.43934L7.43842 6.78217C7.14553 7.07506 7.14553 7.54994 7.43842 7.84283C7.73131 8.13572 8.20619 8.13572 8.49908 7.84283L11.7803 4.56158C12.0732 4.26869 12.0732 3.79381 11.7803 3.50092L8.49908 0.21967C8.20619 -0.0732233 7.73131 -0.0732233 7.43842 0.21967Z",
    fill: "#8d8d8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconLightGray);
export default __webpack_public_path__ + "static/media/sendIconLightGray.1e96e898defcb98201019e3bad0913fd.svg";
export { ForwardRef as ReactComponent };